module.exports = "\n<div class=\"view-port\" style=\"\noverflow: hidden;\ndisplay: flex;\nflex-direction: column;\nheight: 100%;\nwidth: 100%;\n\">\n<h3 class=\"module-header\" style=\"margin-top: 1rem; margin-left: 14px;\">\n    <span style=\"margin-left:8px;\">Migration</span>\n</h3>\n<iframe \n    class=\"embedded-content-view\" \n    name=\"migration-embed\" \n    style=\"margin-top: 5px;\"\n    [src]=\"iframeUrl\" \n    frameborder=\"0\">\n</iframe>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/migration/migration-embed.html
// module id = qNAa
// module chunks = 0